import { X, Send } from "lucide-react";

export default function TelegramPopup({ onClose, link }) {
  return (
    <div className="telegram-overlay" data-testid="telegram-popup">
      <div className="telegram-popup animate-fade-in-up">
        <button className="telegram-close" onClick={onClose} data-testid="telegram-close-btn">
          <X size={18} />
        </button>
        <div className="telegram-icon-wrapper">
          <Send size={28} className="text-[#d4af37]" />
        </div>
        <h3 className="heading-serif text-xl text-white mb-2">Join Our Channel</h3>
        <p className="text-sm text-slate-400 mb-5">
          Stay updated with the latest offers, rewards, and announcements. Join our Telegram channel now!
        </p>
        <a
          href={link || "https://t.me/amazoneproduct"}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-gold inline-block text-center"
          data-testid="telegram-join-btn"
        >
          Join Telegram Channel
        </a>
        <button
          className="text-slate-500 text-xs mt-3 hover:text-slate-300 transition-colors"
          onClick={onClose}
          data-testid="telegram-skip-btn"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}
